// extracted by mini-css-extract-plugin
export default {"mainContainer":"style_mainContainer__F6yXY","header":"style_header__FBWiq","button":"style_button__-Lnjv","activeButton":"style_activeButton__Cn9cB"};